export enum UserMessages {
    None = 0,
    ExecutionStarted = 1,
    LoadSuspects = 2,
    LoadErrors = 4,
    LoadLogs = 8,
    LoadNextRuns = 16,
    LoadLastRuns = 32,
    LoadStepStatus = 64,
    SessionStarted = 128,
    SessionFinished = 256,
    LoadMachines = 512,
    AgentConnected = 1024,
    AgentDisconnected = 2048,
    LoadScheduleStatus = 4096,
    Notify = 8192
}